import React from 'react';
import Header from '../includes/Header.jsx';
import Footer from '../includes/Footer.jsx';
import './style.css'
import { Helmet } from 'react-helmet-async';


const DisclaimerPage = ({ loginstate, onSignOut, user }) => {
    return (
        <div className="privacy-page">
            <Helmet>
                <title>OfferGuru - Отказ от ответственности</title>
                <meta name="description" content="Отказ от ответственности сервиса OfferGuru — генератор коммерческих предложений." />
            </Helmet>
            <Header loginstate={loginstate} onSignOut={onSignOut} user={user} />
            <main>
                <div className="row mb-3">
                    <div className="col privacy-content">
                        <div id="inputResult">
                            <div className="row mb-4">
                                <div className="col">
                                    <h4><strong>Отказ от ответственности</strong></h4>
                                </div>
                            </div>

                            <div className="row mb-4 text-start">
                                <div className="col">
                                    <h5>1. Общие положения</h5>
                                    <div className="descr">
                                        Сервис OfferGuru (далее — «Сервис») предоставляется на условиях «как есть» (as is). Используя Сервис, Вы принимаете условия настоящего отказа от ответственности.
                                    </div>
                                    <div className="ol">
                                        <div className="li">
                                            1.1. Сервис предоставляет инструменты для создания коммерческих предложений и не является средством массовой информации.
                                        </div>
                                        <div className="li">
                                            1.2. Если Вы не согласны с условиями данного отказа от ответственности, прекратите использование Сервиса.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-4 text-start">
                                <div className="col">
                                    <h5>2. Ответственность за содержание</h5>
                                    <div className="ol">
                                        <div className="li">
                                            2.1. Вся ответственность за содержание создаваемых коммерческих предложений, включая корректность цен, описаний товаров и услуг, а также реквизитов, лежит исключительно на пользователе.
                                        </div>
                                        <div className="li">
                                            2.2. Администрация Сервиса не проверяет и не подтверждает достоверность информации, вносимой пользователями.
                                        </div>
                                        <div className="li">
                                            2.3. Администрация не несёт ответственности за любые убытки, возникшие в результате использования или невозможности использования созданных коммерческих предложений.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-4 text-start">
                                <div className="col">
                                    <h5>3. Расчёты и цены</h5>
                                    <div className="ol">
                                        <div className="li">
                                            3.1. Расчёт итоговых сумм (итого, оборудование, работы) производится автоматически на основании данных, введённых пользователем.
                                        </div>
                                        <div className="li">
                                            3.2. Администрация не гарантирует абсолютную точность автоматических расчётов и рекомендует проверять итоговые цифры перед отправкой контрагенту.
                                        </div>
                                        <div className="li">
                                            3.3. Администрация не несёт ответственности за финансовые потери, связанные с ошибками в расчётах.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-4 text-start">
                                <div className="col">
                                    <h5>4. Доступность Сервиса</h5>
                                    <div className="ol">
                                        <div className="li">
                                            4.1. Администрация прилагает разумные усилия для обеспечения бесперебойной работы Сервиса, но не гарантирует его доступность в любое время.
                                        </div>
                                        <div className="li">
                                            4.2. Администрация вправе приостанавливать работу Сервиса для проведения технических работ с предварительным уведомлением или без такового.
                                        </div>
                                        <div className="li">
                                            4.3. Администрация не несёт ответственности за убытки, вызванные временной недоступностью Сервиса.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-4 text-start">
                                <div className="col">
                                    <h5>5. Сохранность данных</h5>
                                    <div className="ol">
                                        <div className="li">
                                            5.1. Администрация принимает меры для сохранности данных пользователей, однако не гарантирует их защиту от потери, повреждения или несанкционированного доступа.
                                        </div>
                                        <div className="li">
                                            5.2. Пользователь несёт ответственность за создание резервных копий своих данных.
                                        </div>
                                        <div className="li">
                                            5.3. Администрация не несёт ответственности за утрату данных в случае форс-мажорных обстоятельств.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-4 text-start">
                                <div className="col">
                                    <h5>6. Сторонние ресурсы</h5>
                                    <div className="ol">
                                        <div className="li">
                                            6.1. Сервис может содержать ссылки на сторонние сайты. Администрация не несёт ответственности за содержание, доступность и достоверность информации на таких ресурсах.
                                        </div>
                                        <div className="li">
                                            6.2. Использование сторонних сервисов (в т.ч. хостинг-провайдеров, платёжных систем) регулируется их собственными условиями.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-4 text-start">
                                <div className="col">
                                    <h5>7. Ограничение ответственности</h5>
                                    <div className="descr">
                                        В максимальной степени, допускаемой действующим законодательством, Администрация Сервиса не несёт ответственности за любые прямые, косвенные, случайные, особые или возникшие вследствие убытки, включая, но не ограничиваясь:
                                    </div>
                                    <div className="ol">
                                        <div className="li">
                                            — потерю доходов или прибыли;
                                        </div>
                                        <div className="li">
                                            — потерю данных;
                                        </div>
                                        <div className="li">
                                            — убытки, возникшие в результате использования или невозможности использования Сервиса;
                                        </div>
                                        <div className="li">
                                            — убытки, возникшие вследствие ошибок в расчётах или содержании коммерческих предложений.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-4 text-start">
                                <div className="col">
                                    <h5>8. Изменение условий</h5>
                                    <div className="ol">
                                        <div className="li">
                                            8.1. Администрация оставляет за собой право в одностороннем порядке изменять настоящий отказ от ответственности без предварительного уведомления пользователей.
                                        </div>
                                        <div className="li">
                                            8.2. Новая версия вступает в силу с момента её публикации на данной странице.
                                        </div>
                                        <div className="li">
                                            8.3. Продолжение использования Сервиса после внесения изменений означает согласие пользователя с обновлёнными условиями.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-4 text-start">
                                <div className="col">
                                    <h5>9. Применимое право</h5>
                                    <div className="ol">
                                        <div className="li">
                                            9.1. Настоящий отказ от ответственности регулируется и толкуется в соответствии с законодательством Российской Федерации.
                                        </div>
                                        <div className="li">
                                            9.2. Все споры, возникающие в связи с использованием Сервиса, подлежат разрешению в судебном порядке по месту нахождения Администрации.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default DisclaimerPage;
